import { createContext, useContext, useEffect, useState } from "react";

const AuthContext = createContext(null);

const AUTH_KEY = "ybp_auth_v1";

// Demo-mode keys cleared on logout / tab close so the next visitor
// always sees an unbranded portal.
const DEMO_KEYS = ["ybp_auth_v1", "ybp_tenant_v1", "ybp_user_theme_v1"];

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    try {
      // sessionStorage = per-tab; auto-clears on tab close.
      const raw = sessionStorage.getItem(AUTH_KEY);
      if (raw) setUser(JSON.parse(raw));
    } catch (_e) {
      // ignore
    }
    setReady(true);
  }, []);

  const login = ({ email, password }) => {
    if (
      email.trim().toLowerCase() === "demo@demo.com" &&
      password === "demo123"
    ) {
      const u = { name: "Demo User", email: "demo@demo.com", role: "Owner" };
      setUser(u);
      try {
        sessionStorage.setItem(AUTH_KEY, JSON.stringify(u));
      } catch (_e) {
        // ignore
      }
      return { ok: true };
    }
    return {
      ok: false,
      error: "Invalid credentials. Use demo@demo.com / demo123.",
    };
  };

  const logout = () => {
    setUser(null);
    try {
      // Wipe every demo-state key so the next visitor on this tab gets a
      // brand-new, unbranded portal — no leftover business name or logo.
      DEMO_KEYS.forEach((k) => {
        sessionStorage.removeItem(k);
        // Also clear localStorage keys in case any older deploy wrote there.
        localStorage.removeItem(k);
      });
    } catch (_e) {
      // ignore
    }
    // Full reload back to login so every React context re-initializes from
    // defaults — guarantees zero residual branding.
    window.location.assign("/login");
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, ready }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used inside AuthProvider");
  return ctx;
}
